import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "copy-toast"
};
const _hoisted_2 = { class: "copy-toast__text" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'Toast',
    props: {
        show: { type: Boolean },
        message: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, { name: "toast" }, {
                default: _withCtx(() => [
                    (__props.show)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("span", _hoisted_2, _toDisplayString(__props.message), 1)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
